import { styled } from "@mui/material";
import Button from "components/ui/Button";
import { useSettingContext } from "context/SettingContext";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const StyledButton = styled(Button)(({ theme, variant, disabled }) => ({
  width: variant === "cancel" ? "110px" : "160px",
  fontFamily: "karla",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: disabled ? "#B0B0B0" : variant === "save_user" ? "#50C878" : variant === "cancel" ? "#E77B7B" : "#FFF",
  border: `1px solid ${disabled ? "#B0B0B0" : variant === "save_user" ? "#50C878" : variant === "cancel" ? "#E77B7B" : "#fff"}`,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: disabled ? "transparent" : variant === "save_user" ? "#50C878" : variant === "cancel" ? "#E77B7B" : "#fff",
    color: disabled ? "#B0B0B0" : variant === "save_user" ? "#fff" : variant === "cancel" ? "#fff" : "#000",
  },
  "&.Mui-disabled": {
    backgroundColor: "transparent",
    color: "#444444",
    border: "1px solid #444444",
    cursor: "not-allowed",
    pointerEvents: "none",
  },
}));

const EditUserChildHeader = ({}) => {
  const { setCancelEditUserModal, cancelEditChnages, createBtn, creatBtnName, isDisable, onSave } = useSettingContext();
  const navigation = useNavigate();
  const location = useLocation();

  const handleOpenModal = () => {
    if (cancelEditChnages) {
      const state = { ...location.state, isEditUser: false, name: [`Users`] };
      navigation("/Setting/users", { state });
      setCancelEditUserModal(false);
    }
    setCancelEditUserModal(true);
  };

  return (
    <div style={{ display: "grid", gridAutoFlow: "column" }}>
      <div className="child-header-sub" style={{ marginLeft: "20px", marginRight: "20px" }}>
        <span style={{ color: "#fff", fontFamily: "poppins", fontSize: "24px", fontWeight: "400" }}>Edit User</span>
      </div>
      <div className="child-header-sub" style={{ justifyContent: "flex-end", marginRight: "20px" }}>
        <StyledButton variant="cancel" onClick={handleOpenModal}>
          Cancel
        </StyledButton>
        {createBtn && (
          <StyledButton variant="save_user" disabled={isDisable} onClick={onSave}>
            {creatBtnName}
          </StyledButton>
        )}
      </div>
    </div>
  );
};

export default EditUserChildHeader;
